import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  TextField,
} from "@mui/material";

import React, { useEffect, useState } from "react";

import CustomizedLetter from "../../documents/LetterFormat/CustomizedLetter";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import TextEditorComponent from "../../common/components/TextEditorComponent";
import { connect } from "react-redux";
import { showError } from "../../toastify";
import {
  updateCasePendingLetter,
  reviewLetter,
} from "../../../store/discipline/actions";
import InstitutionDetails from "../../training/components/InstitutionDetails";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
const maxCharCount = 1500;

const ViewLetterDialog = (props) => {
  const {
    action,
    pendingLetter,
    employee,
    setShowLetter,
    showLetter,
    enableToFillLetter,
    loading,
    setEnableToFillLetter,
    updateCasePendingLetter,
    rejected,
    cancelled,
    selectedLetter,
    onUpdateLetter,
    decisionLevel,
    reviewLetter,
  } = props;

  const [letter, setLetter] = useState(selectedLetter || pendingLetter);
  const { hasPermissions } = useRequiredAuth();
  const [localStorageKey, setLocalStorageKey] = useState({
    letter: `${letter?.caseId}-draftCaseContent`,
    cc: `${letter?.caseId}-copiedInstitution`,
  });
  const [formData, setFormData] = useState({
    id: letter?.id,
    caseId: letter?.caseId,
    letterBodyContent: letter?.letterBodyContent,
    ccInstitutionNames: letter?.ccInstitutionNames,
    action: "Update",
    reason: "",
  });

  const [showAddReviewDialog, setShowAddReviewDialog] = useState(false);
  const [reason, setReason] = useState("");
  const [letterFooterContent, setLetterFooterContent] = useState(null);
  const [ccEmails, setCCEmails] = useState(
    letter && !!letter.ccEmails ? JSON.parse(letter?.ccEmails || []) : []
  );
  // console.log(localStorageKey);
  useEffect(() => {
    window.localStorage.setItem(
      localStorageKey.letter,
      letter?.letterBodyContent
    );
    window.localStorage.setItem(localStorageKey.cc, letter?.ccInstitutionNames);
  }, [letter]);

  useEffect(() => {
    if (onUpdateLetter) {
      formData.letterBodyContent = window.localStorage.getItem(
        localStorageKey.letter
      );
      formData.ccInstitutionNames = window.localStorage.getItem(
        localStorageKey.cc
      );
      formData.ccEmails = JSON.stringify(ccEmails);
      onUpdateLetter(formData);
    }
  }, [formData, ccEmails]);

  const onClose = () => {
    setShowLetter(false);
  };

  const getEditorContent = (data) => {
    setFormData((prevForm) => ({
      ...prevForm,
      letterBodyContent: data.contents,
    }));
  };
  const getEditorContent3 = (data) => {
    // console.log(data);
    setFormData((prevForm) => ({
      ...prevForm,
      ccInstitutionNames: data.contents,
    }));
    // letter.ccInstitutionNames = data.contents;
  };
  const handleLoadFooterContent = (data) => {
    // console.log(data);
    setLetterFooterContent(data);
  };

  const handleUpdateLetter = (isGoingNextPage) => {
    if (!letterFooterContent?.entity?.acronym) {
      showError(`The institution acronym is missing!`);
      return false;
    }

    if (
      !!letterFooterContent &&
      !letterFooterContent?.entity?.institutionPhone
    ) {
      showError(`The institution phone number is required. Please update it`);
      return false;
    }

    if (
      letterFooterContent?.entity?.institutionPhone.includes("+25078XXXXXXX")
    ) {
      showError(
        `The institution phone number (${
          letterFooterContent?.entity?.institutionPhone || ""
        }) does not seem correct. Please update it.`
      );
      return false;
    }

    if (
      !!letterFooterContent &&
      !letterFooterContent?.entity?.institutionEmail
    ) {
      showError(`The institution email is required. Please update it`);
      return false;
    }

    if (letterFooterContent?.entity?.institutionEmail.includes("example")) {
      showError(
        `The institution email (${
          letterFooterContent?.entity?.institutionEmail || ""
        }) does not seem correct. Please update it.`
      );
      return false;
    }

    if (!!letterFooterContent && !letterFooterContent?.entity?.poBox) {
      showError(`The institution PO.Box is required. Please update it`);
      return false;
    }

    if (!!letterFooterContent && !letterFooterContent?.entity?.websiteUrl) {
      showError(`The institution website url is required. Please update it`);
      return false;
    }
    if (!!letterFooterContent && !letterFooterContent?.entity?.twitterPage) {
      showError(
        `The institution former(twitter) is required. Please update it`
      );
      return false;
    }
    formData.letterBodyContent = window.localStorage.getItem(
      localStorageKey.letter
    );
    if (formData?.letterBodyContent.includes("................ (please specify/insert any of the reasons provided under Article 40 (10), (20) of the above mentioned Law)")) {

      showError("Please update your letter, as it seems you haven't provided a reason for the proposed provisional suspension of this employee.");

      return;
    }
    if (formData?.letterBodyContent.includes("................ ")) {

      showError("Kindly update your letter, as it appears you have not made any edits yet.");

      return;
    }
    
    if (formData?.letterBodyContent.includes("[Kindly insert the proposed sanction here")) {

      showError("Kindly update your letter, as it appears you have not made any edits to the proposed sanction.");

      return;
    }

    formData.ccInstitutionNames = window.localStorage.getItem(
      localStorageKey.cc
    );
    formData.ccEmails = JSON.stringify(ccEmails);

    if (formData.action === "Review") {
      reviewLetter(letter?.id, formData, setShowAddReviewDialog, setShowLetter);
    } else {
      updateCasePendingLetter(letter?.id, formData, (status) => {
        if (!!isGoingNextPage && !!status) setEnableToFillLetter(false);
      });
    }
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showLetter}
        fullWidth
        maxWidth={"md"}
      >
        <DialogTitle>
          <Typography
            variant="overline"
            display="block"
            className="font-weight-bold"
          >
            <span
              className={`badge bg-${
                letter?.letterStatusId === 1
                  ? "primary"
                  : letter?.letterStatusId === 2
                  ? "success"
                  : letter?.letterStatusId === 4
                  ? "warning"
                  : "danger"
              } text-white px-2`}
            >
              {letter?.letterStatusName}
            </span>{" "}
            - {letter?.letterNo || ""} <br />
            <span className="text-primary">{letter?.letterDesc || ""}</span>
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent className="mt-0 mx-0" dividers>
          <Box sx={{ width: "100%", minHeight: "95vh" }} className="mt-1">
            <div className="mx-2 w-full">
              <CustomizedLetter
                disableToEditLetterHeader={true}
                enableToFillLetter={enableToFillLetter}
                rejected={rejected}
                cancelled={cancelled}
                ccSelectForm={
                  <>
                    <strong>Enter CC Institution Email</strong>
                    <ReactMultiEmail
                      placeholder="Enter CC Institution Email"
                      emails={ccEmails}
                      onChange={(_emails) => {
                        setCCEmails(_emails);
                      }}
                      getLabel={(email, index, removeEmail) => {
                        return (
                          <div data-tag key={index}>
                            {email}
                            <span
                              data-tag-handle
                              onClick={() => removeEmail(index)}
                            >
                              ×
                            </span>
                          </div>
                        );
                      }}
                    />
                  </>
                }
                ccEmails={ccEmails}
                docLetterNo={letter?.letterNo || ""}
                signContent={
                  <>
                    <InstitutionDetails
                      headOfInstitution={{
                        isDelegated: letter?.isActingHeadOfInstitution || false,
                        isMinster: letter?.isMinster || false,
                        firstName: letter?.approverFirstName,
                        lastName: letter?.approverLastName,
                        institutionName: letter?.approverInstitutionName,
                        positionName: letter?.approverPositionName,
                        institutionName: letter?.approverInstitutionName || "",
                        canAddInstitutionName:
                          letter?.approverCanAddInstitutionName || false,
                      }}
                      userSignature={null}
                    />
                  </>
                }
                subTitle={
                  "Dear " +
                  (employee.lastName.toUpperCase() + " " + employee.firstName)
                }
                recipientContent={
                  <>
                    {employee.lastName.toUpperCase() + " " + employee.firstName}{" "}
                    <br />
                    Tel: {employee.phoneNumber} <br />
                    Email: {employee.email} <br />
                  </>
                }
                entitySectorId={employee?.entitySectorId || null}
                letterBodyContentInput={
                  <>
                    <TextEditorComponent
                      id="editor-exit-textarea"
                      options={{
                        autoSave: false,
                        localStorageKey: localStorageKey.letter,
                        maxCharCount: maxCharCount,
                        defaultValue: !!window.localStorage.getItem(
                          localStorageKey.letter
                        )
                          ? window.localStorage.getItem(localStorageKey.letter)
                          : formData?.letterBodyContent,
                      }}
                      onEditorChange={(data) => {
                        getEditorContent(data);
                      }}
                    />
                  </>
                }
                letterBodyContent={formData?.letterBodyContent || ""}
                title={letter?.letterTitle || ""}
                copiedInstitutionContentInput={
                  <>
                    <br />
                    <strong>Enter CC Institution Name</strong>
                    <TextEditorComponent
                      id="editor-textarea6"
                      options={{
                        autoSave: false,
                        height: "200px",
                        localStorageKey: localStorageKey.cc,
                        maxCharCount: maxCharCount,
                        defaultValue: !!window.localStorage.getItem(
                          localStorageKey.cc
                        )
                          ? window.localStorage.getItem(localStorageKey.cc)
                          : formData?.ccInstitutionNames,
                      }}
                      onEditorChange={(data) => {
                        getEditorContent3(data);
                      }}
                    />
                  </>
                }
                copiedInstitutionContent={formData?.ccInstitutionNames || ""}
                loadFooterContent={(data) => handleLoadFooterContent(data)}
              />
            </div>
          </Box>
        </DialogContent>

        {action && (
          <>
            <DialogActions className="d-flex justify-content-center py-2">
              {enableToFillLetter && (
                <>
                  {hasPermissions([`IS_HR`, "IS_SANCTION_INITIATOR"]) && (
                    <Button
                      disabled={loading}
                      onClick={() => {
                        formData.action = "Update";
                        formData.reason = "";
                        handleUpdateLetter(false);
                      }}
                      color={"primary"}
                      variant="contained"
                      size="small"
                      className="float-right mx-1 my-1"
                      startIcon={
                        <span className="material-icons-outlined">save_as</span>
                      }
                    >
                      {loading && formData.action === "Update" ? "Wait.." : <> Save changes</>}
                    </Button>
                  )}
                  {hasPermissions(["IS_SANCTION_INITIATOR"]) &&
                    decisionLevel === 2 &&
                    [1].includes(letter?.letterTypeId) &&
                    letter?.letterStatusId === 1 &&
                    !letter?.isReviewed && (
                      <Button
                        disabled={loading}
                        onClick={() => {
                          setShowAddReviewDialog(true);
                        }}
                        color={"success"}
                        variant="contained"
                        size="small"
                        className="float-right mx-1 my-1"
                        startIcon={
                          <span className="material-icons-outlined">check</span>
                        }
                      >
                        {loading && formData.action === "Review" ? (
                          "Wait.."
                        ) : (
                          <>Approve </>
                        )}
                      </Button>
                    )}
                  {((decisionLevel === 1 &&
                    [6].includes(letter?.letterTypeId) &&
                    letter?.letterStatusId === 1 &&
                    hasPermissions(["IS_HEAD_OF_UNIT"])) ||
                    ([1, 2].includes(decisionLevel) &&
                      [1, 2, 3, 4, 6, 7,8].includes(letter?.letterTypeId) &&
                      letter?.letterStatusId === 1 &&
                      hasPermissions(["IS_HEAD_OF_INSTITUTION","IS_HEAD_OF_INSTITUTION_ACTING"]))) && (
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      className="float-right mx-1 my-1"
                      startIcon={
                        <span className="material-icons-outlined">save_as</span>
                      }
                      onClick={() => {
                        handleUpdateLetter(true);
                      }}
                    >
                      {loading ? "Wait.." : <>Save and sign</>}
                    </Button>
                  )}
                </>
              )}
              {action}
            </DialogActions>
          </>
        )}
      </Dialog>

      {showAddReviewDialog && (
        <ConfirmationDialog
          fullWidth
          confirmationDialog={showAddReviewDialog}
          disabled={!reason}
          message={
            <>
              <div className="text-left">
                <p className="mx-1">
                  Are you sure you want to approve?
                </p>
                <TextField
                  autoFocus
                  fullWidth
                  size="small"
                  multiline
                  rows={4}
                  name="reason"
                  label={`Message..`}
                  variant="outlined"
                  placeholder={`Message..`}
                  value={reason}
                  onChange={(e) => setReason(e.target.value || "")}
                />
              </div>
            </>
          }
          setConfirmationDialog={setShowAddReviewDialog}
          onYes={() => {
            formData.action = "Review";
            formData.reason = reason;
            handleUpdateLetter(false);
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ loading, pendingLetter }) => {
  return {
    loading,
    pendingLetter,
  };
};
export default connect(mapStateToProps, {
  updateCasePendingLetter,
  reviewLetter,
})(ViewLetterDialog);
